import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useAppSelector } from "../redux/hooks";

export const Preview = () => {
  const activeDocumentId = useAppSelector((state) => state.documents.activeDocumentId);
  const activeDocument = useAppSelector((state) =>
    state.documents.documents.find((d) => d.id === activeDocumentId)
  );
  const selectedTheme = useAppSelector(state => state.theme.selectedTheme)
  useEffect(()=> {
    const previewElement = document.getElementById('preview')
    if(previewElement) {
      switch(selectedTheme) {
        case 'theme1':
          previewElement.classList.add('theme1')
          previewElement.classList.remove('theme2')
          previewElement.classList.remove('theme3')
          break;
        case 'theme2':
          previewElement.classList.add('theme2')
          previewElement.classList.remove('theme1')
          previewElement.classList.remove('theme3')
          break;
        case 'theme3':
          previewElement.classList.add('theme3')
          previewElement.classList.remove('theme1')
          previewElement.classList.remove('theme2')
          break;
      }
    }

  },[selectedTheme])



  if (!activeDocument) 
    return <div className="p-4 flex justify-center border-l text-gray-400 text-sm h-full items-center">
              <span>No Content to Preview</span>
            </div>;

  return (
    <div id="preview" className="p-4 border-l overflow-y-auto h-full">
      <ReactMarkdown>{activeDocument.content}</ReactMarkdown>
    </div>
  );
};